export default [
  {
    id: 1,
    question: "How long does the event last for?",
    answer:
      "Most virtual activities will last for 1 hour. This can range from 30 minutes - 2 hours maximum.",
  },
  {
    id: 2,
    question: "What group size?",
    answer:
      "We have options from 6 people up to 500 +. Some virtual events will work with everyone in the same virtual room, such as the cookery and cocktail making. Others such as the escape room and murder mystery will use virtual breakout rooms in teams of approx 5 where you play against each other and then everyone comes back together at the end.",
  },
  {
    id: 3,
    question: "What is the lead time for a virtual event?",
    answer:
      "Lead times can vary from one day to a couple of month depending on the scale of event you are looking to organise. If you are looking to send out kits or hampers to guests we suggest a minimum lead time of two weeks.",
  },
  {
    id: 4,
    question: "Where do you deliver?",
    answer: `Our suppliers can ship nationwide across the UK. If you've got teams in different countries let us know and our experts will come up with a solution for you.`,
  },
  {
    id: 5,
    question: "What platform do you use?",
    answer:
      "Our virtual events will typically run on Zoom, however we can be flexible with this. Let us know your preffered platform when enquiring.",
  },
];
